export const getEnvs = (env, isLite) => ({
  isAnonymous: JSON.parse(env.REACT_APP_WEBCHAT_IS_ANONYMOUS) || isLite,
  hideUploadButton: JSON.parse(env.REACT_APP_WEBCHAT_HIDE_UPLOAD_BUTTON),
  hideNewConversationButton: JSON.parse(env.REACT_APP_WEBCHAT_HIDE_NEWCONVERSATION_BUTTON),
  displayInnerHeader: JSON.parse(env.REACT_APP_WEBCHAT_DISPLAY_INNER_HEADER),
  botAvatarImage: env.REACT_APP_WEBCHAT_BOT_AVATAR_IMAGE_URL,
  soundUrl: env.REACT_APP_WEBCHAT_SOUND_URL,
  botInitials: env.REACT_APP_CHATBOT_NAME.charAt(0),
  forceAutoscrollOnNewMessage: JSON.parse(env.REACT_APP_WEBCHAT_FORCE_AUTOSCROLL),
  refreshTokenTimeout: parseInt(env.REACT_APP_WEBCHAT_REFRESH_TOKEN_TIMEOUT, 10)
})

export const getUrlConfig = (env, isAnonymous) => ({
  baseUrl: `${env.REACT_APP_BOT_LOGIC_API}/api/directline${isAnonymous ? '/anonymous' : ''}`,
  tokenUrl: '/token',
  uploadUrl: '/upload',
  logsUrl: '/logs'
})

export const liteMode = () => {
  const isLite = RegExp(/\/lite/).test(window.location.pathname)
  return isLite
}
